module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_8004.abf5bb0b.png";